export const PAGE_SIZE = 50
export const PAGINATION_PAGE_SIZE = 100
export const MAX_ITEMS_FOR_SELECTION = 50
